import { render, staticRenderFns } from "./class-lesson.vue?vue&type=template&id=f2bce058&scoped=true"
import script from "./class-lesson.vue?vue&type=script&lang=js"
export * from "./class-lesson.vue?vue&type=script&lang=js"
import style0 from "./class-lesson.vue?vue&type=style&index=0&id=f2bce058&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bce058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2bce058')) {
      api.createRecord('f2bce058', component.options)
    } else {
      api.reload('f2bce058', component.options)
    }
    module.hot.accept("./class-lesson.vue?vue&type=template&id=f2bce058&scoped=true", function () {
      api.rerender('f2bce058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/detail-pane/class-lesson.vue"
export default component.exports